import script from "./CMSRolesAndPermissions.vue?vue&type=script&lang=ts&setup=true"
export * from "./CMSRolesAndPermissions.vue?vue&type=script&lang=ts&setup=true"

import "./CMSRolesAndPermissions.vue?vue&type=style&index=0&id=92cd60a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92cd60a8"]])

export default __exports__